import { IPNavLink } from 'baseComponents/Nav/IPNav';
import { navExpandableClass } from './navMainStyles';
import { INavModelItem } from './navModel';

//
// One menu entry as a Fluent Nav link. Used by the rail (NavMain.tsx) and by the callout beside a
// pinned group header (NavHintCallout.tsx).
//

export interface INavLinkOptions {
  /** Give the row its children, so it can expand in place: Tasks and the nested layout entries. */
  withLinks: boolean;
  /**
   * Mark the row for the hint callout. Hovering, focusing or clicking it opens one, and the browser's
   * own tooltip stays off, so the two do not show together.
   */
  hintable: boolean;
  /** The icon of a row that has none. The icon rail passes a dot; the full menu leaves the row bare. */
  iconForIconless?: string;
}

export const toNavLink = (item: INavModelItem, options: INavLinkOptions): IPNavLink => {
  const isExpandable = options.withLinks && (item.children?.length ?? 0) > 0;
  const iconClassName = isExpandable
    ? [item.className, navExpandableClass].filter((name) => name !== undefined).join(' ')
    : item.className;

  return {
    name: item.label,
    url: '',
    key: item.id,
    iconProps: { iconName: item.iconName ?? options.iconForIconless, className: iconClassName },
    links: isExpandable ? item.children?.map((child) => toNavLink(child, options)) : undefined,
    isExpanded: isExpandable ? item.isExpanded : undefined,
    // Fluent falls back to the name when title is undefined; an empty string keeps the tooltip off.
    title: options.hintable ? '' : undefined,
    // Fluent forwards data attributes to the row element; the hint hook finds the row by this one.
    'data-nav-id': options.hintable ? item.id : undefined,
  };
};
